import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CuentaBancariaForm from "components/abonos/CuentaBancariaForm";
import { errorAlert } from "helpers/alerts";
import { hasSameValues } from "helpers/util";
import { setLoading } from "redux/slices/uiSlice";
import { updateCuenta } from "redux/slices/abonos/abonosSlice";
import { updateCuentaService } from "services/abonos/abonosService";

const EditCuentaScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentCuenta } = useSelector((store) => store.abonos);

  const defaultValues = {
    bank: currentCuenta?.bank,
    accountNumber: currentCuenta?.accountNumber,
    clabe: currentCuenta?.clabe,
    beneficiary: currentCuenta?.beneficiary,
  };

  const handleSubmit = (data) => {
    if (!hasSameValues(defaultValues, data)) {
      navigate(-1);
      return;
    }
    dispatch(setLoading(true));
    updateCuentaService(currentCuenta.id, data)
      .then(() => {
        dispatch(updateCuenta({ id: currentCuenta.id, data }));
        navigate(-1);
      })
      .catch((error) => errorAlert(error))
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <CuentaBancariaForm
      title={"Administración de Cuentas"}
      goBack={() => navigate(-1)}
      submit={handleSubmit}
      defaultValues={defaultValues}
    />
  );
};

export default EditCuentaScreen;
